import { useState, useEffect } from "react";

const Spacer = (props) => {
  const [space, setSpace] = useState({});
  useEffect(() => {
    if (props.marginTop) {
      setSpace({ marginTop: props.marginTop + "px" });
    }
    if (props.marginBottom) {
      setSpace({ marginBottom: props.marginBottom + "px" });
    }
    if (props.marginLeft) {
      setSpace({ marginLeft: props.marginLeft + "px" });
    }
    if (props.marginRight) {
      setSpace({ marginRight: props.marginRight + "px" });
    }
    if (props.width) {
      setSpace({ width: props.width + "px" });
    }
  }, [props]);
  return <div style={space}></div>;
};

export default Spacer;
